<template>
    <div class="slider-container">

        <div class="slider-row">
            <!-- Show current group of 3 (or less) -->
            <!-- <div v-for="person in currentGroupPeople" 
                 :key="person.index"
                 class="person-card small">
                <img :src="person.image" :alt="person.name" />
                <div class="name-container">
                    <h2>{{ person.name }}</h2>
                    <p>{{ person.position }}</p>
                    <p>{{ person.about }}</p>
                </div>
            </div> -->
            <div class="coach-container" v-for="person in currentGroupPeople"  :key="person.index">
                <img :src="person.image" :alt="person.name"/>
                
                <div class="image-text">
                    <h4 class="mt-3">{{ person.name }}</h4>
                    <p>{{ person.position }}<br>{{ person.email }}<br>{{ person.phone }}<br>{{ person.about }}</p>
                </div>
                <center>
                <div class="email-img">
                    <a :href="'mailto:' + person.email" class="email-icon" aria-label="Email">
                    <img src="../../assets/images/Letter.png" alt="">
                    </a>
                </div>
                </center>
            </div>
        </div>

        <!-- Controls - only show if more than 3 people -->
        <div class="controls" v-if="people.length > 3">
            <button @click="prev">
                <img src="../../assets/logo/prev.png" alt="Previous">
            </button>
            <div class="dots">
                <span v-for="(group, index) in totalGroups" 
                      :key="index" 
                      class="dot"
                      :class="{ active: index === currentGroup }"></span>
            </div>
            <button @click="next">
                <img src="../../assets/logo/next.png" alt="Next">
            </button>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from "vue";
/* eslint-disable */
const props = defineProps({
    people: {
        type: Array,
        required: true,
    },
});

const currentGroup = ref(0);
const itemsPerGroup = 3;

// Calculate total number of groups
const totalGroups = computed(() => 
    Math.ceil(props.people.length / itemsPerGroup)
);

// Get the actual people objects for the current group
const currentGroupPeople = computed(() => {
    const startIndex = currentGroup.value * itemsPerGroup;
    const groupPeople = [];
    
    // Add up to 3 people for the current group
    for (let i = 0; i < itemsPerGroup; i++) {
        const index = startIndex + i;
        if (index < props.people.length) {
            groupPeople.push({
                ...props.people[index],
                index: index // include original index if needed
            });
        }
    }
    
    return groupPeople;
});

const next = () => {
    if (currentGroup.value < totalGroups.value - 1) {
        currentGroup.value++;
    } else {
        // Loop back to first group
        currentGroup.value = 0;
    }
};

const prev = () => {
    if (currentGroup.value > 0) {
        currentGroup.value--;
    } else {
        // Loop to last group
        currentGroup.value = totalGroups.value - 1;
    }
};
</script>

<style lang="scss" scoped>

.coaches-grid {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: auto;
    padding: 20px;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
    .coaches {

       padding: 0px;
    }
    .coaches-grid {
        display: flex;
        flex-direction: row !important;
    }

    .coach-container{
        width: 300px !important;
    }
}

.coach-container{
    width: 305px;
    height: 480px;
    gap: 28px;
    opacity: 1;
    padding-bottom: 20px;
    border-radius: 12px;
    border: 1px solid #FFFFFF;
    backdrop-filter: blur(20px);
    background: #FFFFFF26;
    margin: 10px;
    padding: 10px;

    img{
        border-radius: 12px;
        width: 100%;
        height: 280px;
        opacity: 1;
        
    }
}
.image-text{
    
    h4{
        //font-family: BT Beau Sans;
        font-weight: 400;
        font-size: 16px;
        letter-spacing: 0%;
        text-align: center;
        color: #FFFFFF;
    }
    p{
        margin-top: -20px;
        font-size: 13px;
        text-align: center;
        color: #FFFFFF;
        line-height: 1.4 ;
    }
}
.email-img {
  //width: 50px;                /* adjust size as needed */
  //height: 50px;               /* keep equal width and height for a perfect circle */
  //border-radius: 50%;          /* makes it a circle */
  border: 0px solid #fff;      /* white border */
  overflow: hidden;            /* ensures image doesn’t overflow the circle */
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;  
  cursor: pointer;   /* optional: faint background if image has transparency */
}

.email-img img {
  margin-top: 4px;
  width: 50%;
  height: 50%;
  object-fit: cover;           /* ensures the image fills the circle nicely */
  //border-radius: 50%;          /* keeps image circular */
}

.slider-container {
    position: relative;
    width: 100%;
    margin-top: 2rem;
    text-align: center;
}

@media (max-width: 768px) {
    .slider-row {
    display: flex;
    flex-direction: column;
    /* space between images */
}
}
.slider-row {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 40px;
    /* space between images */
}

.person-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 0.3s ease;
    position: relative;
}

.person-card img {
    width: 320px;
    height: 348px;
    border-radius: 20px;
    object-fit: cover;
    border: 3px solid transparent;
}

.person-card {
    position: relative;
}

.person-card .name-container {
    border: 2px solid white;
    width: 95%;
    height: 88px;
    border-radius: 12px;

    background-color:#1392463b;
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 8px;
    color: white;
}

.person-card h2 {
    /* margin-top: 10px; */
    margin: 0%;
    padding: 0%;
    font-size: 18px;
    font-weight: 700px;
    font-family: "Open Runde", sans-serif;
    text-align: center;
}

.person-card p {
    /* margin-top: 10px; */
    margin: 0%;
    padding: 0%;
    font-size: 13px;
    font-weight: 500;
    font-family: "Open Runde", sans-serif;
    text-align: center;
}

/* Current (center) image */
.person-card.active {
   // transform: scale(1.1);
}

/* .person-card.active img {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
} */

/* Side images */
.person-card.small {
    width: 320px;
    height: 348px;
    transform: scale(0.9);
    cursor: pointer;
}

.controls {
    margin-top: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
}

.controls button {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    border: 1px solid #00000033;
    box-shadow: 0 4px 10px rgba(58, 57, 57, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #FFFFFF;
    margin-top: 2rem;
    transition: background 0.3s;
}

.controls button:hover {
    background: #eee;
}

.dots {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding-top: 2rem;

    height: 72px;

    span {
        margin: 0%;
        padding: 0%;
    }
}

.dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #D9D9D9;
    transition: background 0.3s ease;
}

.dot.active {
    background-color: #000000;
}

@media (max-width: 768px) {
   

    // .person-card {

    //     width: 100%;
    // }

    // .person-card img {
    //     width: 100%;
    //     /* make image responsive */
    //     /* max-width: 320px; */
    //     height: auto;
    // }
}
</style>
